import { useEffect, useRef } from "react";

const highlights = [
  { icon: "ri-calendar-check-line", label: "Desde 2010", desc: "Mais de 15 anos de experiência em direito previdenciário" },
  { icon: "ri-heart-line", label: "Atendimento Humanizado", desc: "Tratamos cada caso com atenção, empatia e dedicação" },
  { icon: "ri-computer-line", label: "Online e Presencial", desc: "Atendemos de qualquer lugar do Brasil, sem complicação" },
];

export default function SobreSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            (entry.target as HTMLElement).style.opacity = "1";
            (entry.target as HTMLElement).style.transform = "translateY(0)";
          }
        });
      },
      { threshold: 0.15 }
    );
    const elements = sectionRef.current?.querySelectorAll(".reveal-sobre");
    elements?.forEach((el) => {
      (el as HTMLElement).style.opacity = "0";
      (el as HTMLElement).style.transform = "translateY(30px)";
      (el as HTMLElement).style.transition = "opacity 0.7s ease, transform 0.7s ease";
      observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="sobre"
      ref={sectionRef}
      className="py-20 md:py-28"
      style={{ backgroundColor: "#FFFFFF" }}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="reveal-sobre text-center mb-16">
          <span
            className="inline-block text-sm font-semibold tracking-widest uppercase mb-3"
            style={{ fontFamily: "Montserrat, sans-serif", color: "#0B4D6F" }}
          >
            Conheça a Advogada
          </span>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4"
            style={{ fontFamily: "Cinzel, serif", color: "#1A1A1A" }}
          >
            Sobre a Dra. Jordanna Rates
          </h2>
          <div className="mx-auto" style={{ width: "60px", height: "3px", backgroundColor: "#0B4D6F", borderRadius: "2px" }} />
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Image */}
          <div className="reveal-sobre flex-shrink-0 w-full lg:w-auto">
            <div
              className="relative mx-auto"
              style={{ width: "340px", maxWidth: "100%" }}
            >
              <div
                className="absolute -top-4 -left-4 w-full h-full rounded-2xl"
                style={{ backgroundColor: "#F2ECD4", zIndex: 0 }}
              />
              <div
                className="relative rounded-2xl overflow-hidden"
                style={{ height: "420px", zIndex: 1, border: "4px solid #F2ECD4" }}
              >
                <img
                  src="https://storage.readdy-site.link/project_files/4f7051cf-de8d-470e-be57-4cb438d07309/09aa726a-0f48-4013-aa57-ef711da24b23_jordanna-rates---sobre.jpg?v=c1219c6025f845b553a2aff433741eec"
                  alt="Dra. Jordanna Rates - Advogada especialista em benefícios previdenciários INSS"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Experience badge */}
              <div
                className="absolute -bottom-5 -right-5 rounded-2xl p-4 text-center z-10"
                style={{ backgroundColor: "#0B4D6F", minWidth: "120px" }}
              >
                <div
                  className="text-3xl font-bold text-white"
                  style={{ fontFamily: "Cinzel, serif" }}
                >
                  +15
                </div>
                <div
                  className="text-xs text-white/80 mt-1"
                  style={{ fontFamily: "Montserrat, sans-serif" }}
                >
                  Anos de<br />Experiência
                </div>
              </div>
            </div>
          </div>

          {/* Text Content */}
          <div className="reveal-sobre flex-1">
            <p
              className="text-lg leading-relaxed mb-5"
              style={{ fontFamily: "Montserrat, sans-serif", color: "#333" }}
            >
              A <strong>Dra. Jordanna Rates</strong> é advogada especialista em Direito Previdenciário,
              com atuação dedicada exclusivamente à defesa dos direitos de trabalhadores e cidadãos
              que buscam seus benefícios junto ao INSS.
            </p>
            <p
              className="text-base leading-relaxed mb-5"
              style={{ fontFamily: "Montserrat, sans-serif", color: "#555" }}
            >
              Com experiência desde 2010, já ajudou centenas de famílias a conquistarem
              aposentadorias, auxílios e benefícios que muitas vezes foram negados injustamente.
              Seu trabalho é marcado pelo <strong>atendimento humanizado</strong>, pela linguagem
              simples e pelo compromisso com resultados reais.
            </p>
            <p
              className="text-base leading-relaxed mb-10"
              style={{ fontFamily: "Montserrat, sans-serif", color: "#555" }}
            >
              Atende de forma <strong>online e presencial</strong>, facilitando o acesso de pessoas
              de todo o Brasil, especialmente aquelas que vivem em cidades do interior ou têm
              dificuldade de locomoção.
            </p>

            {/* Highlights */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              {highlights.map((item) => (
                <div
                  key={item.label}
                  className="flex flex-col items-center sm:items-start gap-3 p-5 rounded-xl"
                  style={{ backgroundColor: "#F5F5F5" }}
                >
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: "#0B4D6F" }}
                  >
                    <i className={`${item.icon} text-white text-xl`}></i>
                  </div>
                  <div className="text-center sm:text-left">
                    <div
                      className="font-semibold text-sm mb-1"
                      style={{ fontFamily: "Montserrat, sans-serif", color: "#1A1A1A" }}
                    >
                      {item.label}
                    </div>
                    <div
                      className="text-xs leading-relaxed"
                      style={{ fontFamily: "Montserrat, sans-serif", color: "#666" }}
                    >
                      {item.desc}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
